import React from 'react'
import { selectionTypes } from 'constants.js'
import TargetGroupPane from '../targetGroup/TargetGroupPane'
import GeopolygonPane from '../geopolygon/GeopolygonPane'
import BoundaryPane from '../boundary/BoundaryPane'
import AddTargetGroupPane from '../targetGroup/AddTargetGroupPane'
import AddItemPane from '../item/AddItemPane'
import PointBufferPane from './PointBufferPane'
import ShapePane from './ShapePane'
import LinePane from './LinePane'
import MarkerPane from './MarkerPane'
import SavedMarkerPane from './SavedMarkerPane'
import BoundaryListPane from '../boundaryList/BoundaryListPane'
import UserShapefilePane from '../userShapefile/UserShapefilePane'
import UserMarkerfilePane from '../userMarkerfile/UserMarkerfilePane'
import UserPane from '../user/UserPane'
import IsochronePane from './IsochronePane'
import ColorPane from './ColorPane'
import MultiItemPane from './MultiItemPane'
import BulkPointBufferPane from '../item/BulkPointBufferPane'
import BulkIsochronePane from '../item/BulkIsochronePane'
import FolderActionsPane from '../item/FolderActionsPane'

const choosePane = ({ type, item, data }) => {
  if (type === selectionTypes.TARGET_GROUP) {
    return <TargetGroupPane group={item} />
  } else if (type === selectionTypes.GEOPOLYGON) {
    return <GeopolygonPane geopolygon={item} group={data.group} />
  } else if (type === selectionTypes.BOUNDARY) {
    return <BoundaryPane boundary={item} group={data.group} />
  } else if (type === selectionTypes.ZIP_CODE_BOUNDARY) {
    return <BoundaryPane boundary={item} group={data.group} />
  } else if (type === selectionTypes.NEW_TARGET_GROUP) {
    return <AddTargetGroupPane />
  } else if (type === selectionTypes.NEW_ITEM) {
    return <AddItemPane />
  } else if (type === 'FOLDER_ACTIONS') {
    return <FolderActionsPane group={data.group} />
  } else if (type === selectionTypes.POINT_BUFFER) {
    return <PointBufferPane pointBuffer={item} group={data.group} />
  } else if (type === selectionTypes.SHAPE) {
    return <ShapePane shape={item} group={data.group} />
  } else if (type === selectionTypes.LINE) {
    return <LinePane line={item} group={data.group} />
  } else if (type === selectionTypes.MARKER) {
    if (data.edit) {
      return <MarkerPane edit marker={item} group={data.group} />
    } else {
      return <MarkerPane marker={item} group={data.group} />
    }
  } else if (type === selectionTypes.SAVED_MARKER) {
    return <SavedMarkerPane savedMarker={item} group={data.group} />
  } else if (type === selectionTypes.BOUNDARY_LIST) {
    return <BoundaryListPane boundaryList={item} group={data.group} />
  } else if (type === selectionTypes.USER_SHAPEFILE_LIST) {
    return <UserShapefilePane userShapefileList={item} group={data.group} />
  } else if (type === selectionTypes.USER_MARKERFILE_LIST) {
    return <UserMarkerfilePane userMarkerfileList={item} group={data.group} />
  } else if (type === selectionTypes.USER) {
    return <UserPane user={item} />
  } else if (type === selectionTypes.ISOCHRONE) {
    return <IsochronePane isochrone={item} group={data.group} />
  } else if (type === selectionTypes.BULK_POINT_BUFFER) {
    return <BulkPointBufferPane bulkBuffer={item} group={data.group} />
  } else if (type === selectionTypes.BULK_ISOCHRONE) {
    return <BulkIsochronePane bulkIsochrone={item} group={data.group} />
  } else if (type === selectionTypes.COLOR) {
    return <ColorPane />
  } else if (type === selectionTypes.MULTI_ITEMS) {
    return <MultiItemPane key={data.group.pk} geopolygon={item} group={data.group} />
  } else {
    return null
  }
}

export default choosePane
